var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 15.999,
    viewBox: "0 0 16 15.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.33,11H2.666V7H0v5.332a1.26,1.26,0,0,0,1.333,1.333h13.33A1.26,1.26,0,0,0,16,12.332V7H13.33Z",
    transform: "translate(0.002 2.332)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8,0H6.665A.666.666,0,0,0,6,.666V4H2.666a.666.666,0,0,0-.5,1.105L6.83,10.436a.666.666,0,0,0,1,0L12.5,5.1A.666.666,0,0,0,12,4H8.665V.666A.666.666,0,0,0,8,0Z",
    transform: "translate(0.668)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload);
export default __webpack_public_path__ + "static/media/Icon_Download.8bc40e431b26277e9ed4f404a9325e92.svg";
export { ForwardRef as ReactComponent };